import createRoute from '@widesk-ui/tools/createRoute';
import MenuModel   from '@models/website/MenuModel';

const route = createRoute.dashboard(
	'/website_entertainments/:websiteEntertainmentId/menus/mode/:mode',
	'website',
	'MenuDashboard',
	MenuModel.localize(),
);

export default route;
